import React from "react";
import Card from './Card';
import Data from './data';
const Service = () => {
  return (
    <div>
      <div className="my-5">
        <h1 className="tab-center text-center">Regularly Data Updates</h1>
      </div>
      <div className="container-fluid mb-5">
        <div className="row">
          <div className="col-12 col-lg-10 mx-auto">
            <div className="row gy-5">
       
             {
                Data.map((value,index)=>{
                  return <Card imgsrc={value.imgsrc} title={value.title} paths={value.paths}/>
                })
                
             }
            </div>
          </div>


          
        </div>
      </div>
    </div>
  );
};

export default Service;
